module.exports = __webpack_public_path__ + "img/recommend-1.5b954d91.png";